module.exports = __webpack_public_path__ + "media/images/img_mentor01-12844288634344f076ae96a681831356.jpg";